<template>
  <div class="container">
    <h2 style="text-align: center; color: #66b1ff; margin: 80px 0 40px 0">
      欢迎入驻，请填写以下信息
    </h2>
    <hr style="
        width: 600px;
        border: none;
        height: 1px;
        background-color: rgb(102, 177, 255);
      " />
    <!-- margin-bottom:40px; -->
    <el-steps :active="active"> </el-steps>
    <el-form :model="settledForm" status-icon ref="settledForm" :rules="rules" label-width="125px"
      style="width: 400px; margin: 0 auto">
      <!-- 基础资料 -->
      <div v-if="active == 0">
        <h4>基础资料</h4>
        <el-form-item label="公司名称：">
          <el-input type="text" autocomplete="off" placeholder="请输入公司名称" v-model="settledForm.NAME"></el-input>
        </el-form-item>
        <el-form-item label="简称：">
          <el-input type="text" autocomplete="off" placeholder="请输入简称" v-model="settledForm.AB_NAME"></el-input>
        </el-form-item>
        <el-form-item label="联系人：">
          <el-input type="text" autocomplete="off" placeholder="请输入联系人" v-model="settledForm.CONTACT_NAME"></el-input>
        </el-form-item>
        <el-form-item label="联系电话：">
          <el-input type="text" autocomplete="off" placeholder="请输入联系电话" v-model="settledForm.CONTACT_PHONE"></el-input>
        </el-form-item>
        <el-form-item label="邮箱：" prop="E_MAil">
          <el-input type="text" autocomplete="off" placeholder="请输入邮箱" v-model="settledForm.E_MAil" @blur="sendEmail">
          </el-input>
        </el-form-item>
        <el-form-item label="企业代码：">
          <el-input type="text" autocomplete="off" placeholder="请输入企业代码" v-model="settledForm.CODE"></el-input>
        </el-form-item>
        <el-form-item label="开户行：">
          <el-input type="text" autocomplete="off" placeholder="请输入开户行" v-model="settledForm.BANK"></el-input>
        </el-form-item>
        <el-form-item label="银行账号：">
          <el-input type="text" autocomplete="off" placeholder="请输入银行账号" v-model="settledForm.BANK_ACCOUNT"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" style="width: 400px; margin-left: -125px" @click="next">下一步</el-button>
        </el-form-item>
      </div>
      <!-- 经营资质 -->
      <div v-show="active == 1">
        <h4>经营资质 (请先选择企业性质)</h4>
        <el-form-item label="企业性质：">
          <el-select v-model="settledForm.COMPANY_NATURE" multiple placeholder="请选择" filterable style="width: 100%"
            @change="compare" @remove-tag="removeQualification">
            <el-option v-for="(item, index) in companyNatureList" :key="index" :label="item.NATURE_DATA.NATURE_NAME"
              :value="item.NATURE_DATA.NATURE_CODE"></el-option>
          </el-select>
        </el-form-item>
        <div v-for="item in lastArr" :key="item.RELATION_ID">
          <el-form-item :label="item.NAME + ':'">
            <div class="block">
              <el-radio v-model="item.longTime" label="1" style="line-height: 40px; margin-left: 5px">
                长期
              </el-radio>
              <el-date-picker style="width: 275px" v-model="item.EXPIRE_DAY" type="date" placeholder="选择证件过期日期"
                value-format="yyyy-MM-dd" v-if="item.longTime != '1'" @change="setExpireDay(item)"></el-date-picker>
            </div>
            <el-upload style="margin-top: 10px" class="upload-demo" action="/uploadFile" ref="upload"
              list-type="picture" :on-success="
                (res, file) => {
                  AvatarSuccess(item, res, file);
                }
              " :on-remove="handleRemove" :name="addForm.image" :multiple="false" :limit="1"
              accept=".pdf,.xls,.xlsx,.doc,.docx,.jpg,.jpeg,.bmp,.gif,.png" :before-upload="checkFileType">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button style="width: 193px; margin-left: -130px" @click="Previous">上一步</el-button>
          <el-button type="primary" style="width: 193px" @click="next">下一步</el-button>
        </el-form-item>
      </div>
      <!-- 供应产品 -->
      <div v-show="active == 2">
        <h4>供应产品</h4>
        <el-form-item>
          <span style="color: #409eff; margin-left: -130px; cursor: pointer"
            @click="downloadConfigurable">点此下载可配置产品</span>
        </el-form-item>
        <el-form-item label="供应产品：">
          <el-button size="small" type="primary" @click="openExportDialog()">点击上传</el-button>
        </el-form-item>
        <el-form-item label="供应类别：">
          <el-select v-model="CATALOG_ID_LIST" multiple placeholder="请选择" filterable style="width: 100%" clearable>
            <el-option v-for="item in inviterCategoryList" :key="item.CATALOG_ID" :label="item.CATALOG_NAME"
              :value="item.CATALOG_ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button style="width: 193px; margin-left: -130px" @click="Previous">上一步</el-button>
          <el-button type="primary" style="width: 193px" @click="next">确认入驻</el-button>
        </el-form-item>
      </div>
      <!-- 入驻成功 -->
      <div v-show="active == 3" style="text-align: center">
        <i class="el-icon-circle-check" style="display: block; color: #66b1ff; margin: 60px; font-size: 80px"></i>
        <h3 style="color: #66b1ff; margin: 80px 0 40px 0">恭喜你入驻成功！</h3>
      </div>
    </el-form>
    <el-dialog :visible.sync="exportDialog" @close="exportDialog = false" title="上传供应产品" width="400px" center>
      <el-form ref="exportForm" v-model="exportForm">
        <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-remove="handleRemoveTwo"
          :on-success="handleSuccessTwo" :name="this.exportForm.exportGoods" multiple :limit="1" accept=".xls,.xlsx"
          :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传xls/xlsx文件，且不超过500kb
          </div>
        </el-upload>
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button class="operate-btn" @click="exportDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="handleExportGoods">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      on: false,
      FLAG: 1,
      active: 0,
      settledForm: {
        E_MAil: null,
      },
      rules: {
        E_MAil: [{ required: true, message: '请填写电子邮箱', trigger: 'change' }],
      },
      productsSupplied: 'productsSupplied',
      companyNatureList: [],
      status: 0,
      addForm: {
        image: 'SupplierQualify',
      },
      fileList: [],
      file_name: '',
      QUALIFICATION_DATA_LIST: [],
      lastArr: [],
      exportDialog: false,
      exportForm: {
        exportGoods: 'tmp',
      },
      longTime: '0',
      inviterCategoryList: [],
      CATALOG_ID_LIST: [],
    };
  },
  created() {
    this.getCompanyNature();
    this.getInviterCategory();
  },
  methods: {
    // 上传产品导入
    openExportDialog() {
      this.exportDialog = true;
    },
    handleRemoveTwo(file, fileList) {
      this.fileList = [];
      this.file_name = '';
    },
    handleSuccessTwo(response, file, fileList) {
      this.file_name = response.file_name;
    },
    // 邮箱格式校验
    sendEmail() {
      const regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (this.settledForm.E_MAil != '' && !regEmail.test(this.settledForm.E_MAil)) {
        this.$message.show({
          text: '邮箱格式不正确',
          type: 'warning',
        });
        this.settledForm.E_MAil = '';
      }
    },
    handleExportGoods() {
      if (!this.file_name) {
        this.$message.show({ text: '请先上传文件', type: 'warning' });
        return false;
      }
      if (document.body.style.cursor === 'wait') { } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '16006',
            OTYPE: 4,
            COMPANY_ID: Number(this.$route.params.id),
            FILE_NAME: this.file_name,
          };
          http.post(params).then((res) => {
            this.$message.show({ text: '导入成功', type: 'success' });
            this.$refs.upload.clearFiles();
            this.exportDialog = false;
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            this.file_name = '';
            this.$refs.upload.clearFiles();
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    // 点击性质下拉框
    compare() {
      this.on = true;
      const arr = [];
      for (let i = 0; i < this.companyNatureList.length; i++) {
        for (let m = 0; m < this.settledForm.COMPANY_NATURE.length; m++) {
          if (this.settledForm.COMPANY_NATURE[m] === this.companyNatureList[i].NATURE_DATA.NATURE_CODE) {
            const a = this.companyNatureList[i].QUALIFICATION_DATA;
            for (let j = 0; j < a.length; j++) {
              a[j].natureCode = this.settledForm.COMPANY_NATURE[m];
              arr.push(a[j]);
            }
          }
        }
      }
      this.lastArr = arr;
    },
    checkSpace(ipt) {
      const regu = '^[ ]+$';
      const re = new RegExp(regu);
      if (re.test(ipt)) {
        this.$message.show({ text: '非法输入', type: 'warning' });
        return false;
      }
      return true;
    },
    // ----------------
    AvatarSuccess(item, res, file) {
      // item 即为自定义传参的参数
      this.url = res.base_url + res.file_name;
      const a = item.FILE_ARRAY;
      a.FILE_URL = this.url;
      const b = this.url;
      const endRes = b.split('.')[b.split('.').length - 1].toLowerCase();
      if (endRes == 'webp' || endRes == 'jpg' || endRes == 'png' || endRes == 'jpeg') {
        a.FILE_TYPE = 1;
      } else if (endRes == 'docx') {
        a.FILE_TYPE = 3;
      } else if (endRes == 'pdf') {
        a.FILE_TYPE = 2;
      } else {
        a.FILE_TYPE = 30;
      }

      const result = JSON.parse(JSON.stringify(item).replace(/NAME/g, 'QUALIFICATION_NAME'));

      this.QUALIFICATION_DATA_LIST.push(result);
    },
    next() {
      if (this.active == 0) {
        // 输入框校验
        if (!this.settledForm.NAME || !this.settledForm.AB_NAME || !this.settledForm.CONTACT_NAME || !this.settledForm.CONTACT_PHONE || !this.settledForm.E_MAil || !this.settledForm.CODE || !this.settledForm.BANK || !this.settledForm.BANK_ACCOUNT) {
          this.$message.show({ text: '请将信息填写完整', type: 'warning' });
          return;
        }
        if (this.checkSpace(this.settledForm.NAME) && this.checkSpace(this.settledForm.AB_NAME) && this.checkSpace(this.settledForm.CONTACT_NAME) && this.checkSpace(this.settledForm.BANK_ACCOUNT) && this.checkSpace(this.settledForm.BANK)) { } else {
          return;
        }
        if (this.settledForm.CODE.replace(/[^\d]/g, '')) {
          if (this.settledForm.CODE.length > 25) {
            this.$message.show({ text: '企业代码格式不正确，请重新输入！', type: 'warning' });
            return;
          }
        } else {
          this.$message.show({ text: '企业代码格式不正确，请输入', type: 'warning' });
          return;
        }
        if (this.settledForm.CONTACT_PHONE.replace(/[^\d]/g, '')) {
          if (this.settledForm.CONTACT_PHONE.length !== 11) {
            this.$message.show({ text: '请输入正确的手机号', type: 'warning' });
            return;
          }
        } else {
          this.$message.show({ text: '手机号格式不正确，请输入', type: 'warning' });
          return;
        }
        if (this.settledForm.BANK_ACCOUNT.replace(/[^\d]/g, '')) {
          if (this.settledForm.BANK_ACCOUNT.length > 25) {
            this.$message.show({ text: '银行账号格式不正确，请重新输入！', type: 'warning' });
            return;
          }
        } else {
          this.$message.show({ text: '银行账号格式不正确，请输入', type: 'warning' });
          return;
        }
        this.active = 1;
      } else if (this.active == 1) {
        if (this.lastArr.length == 0) {
          this.$message.show({ text: '请先配置企业资质！', type: 'warning' });
          return;
        }
        const num = this.lastArr.length;
        if (this.QUALIFICATION_DATA_LIST.length != num) {
          this.$message.show({ text: '请上传资质(日期不填写将默认长期)', type: 'warning' });
          return;
        }
        for (let i = 0; i < this.QUALIFICATION_DATA_LIST.length; i++) {
          if (this.QUALIFICATION_DATA_LIST[i].FILE_ARRAY.FILE_URL == '') {
            this.$message.show({ text: '请将资质填写完整(包括日期及资质上传)', type: 'warning' });
            return;
          }
          this.active = 2;
        }
      } else if (this.active == 2) {
        // 删除多余元素
        this.QUALIFICATION_DATA_LIST.forEach((item) => {
          delete item.RELATION_ID;
          delete item.STATUS;
          delete item.natureCode;
          delete item.longTime;
        });
        const params = {
          SERVICE_ID: '16006',
          OTYPE: 5,
          COMPANY_ID: Number(this.$route.params.id),
          NAME: this.settledForm.NAME,
          AB_NAME: this.settledForm.AB_NAME,
          CONTACT_NAME: this.settledForm.CONTACT_NAME,
          CONTACT_PHONE: this.settledForm.CONTACT_PHONE,
          EMAIL: this.settledForm.E_MAil,
          COMPANY_CODE: this.settledForm.CODE,
          BANK_NAME: this.settledForm.BANK,
          BANK_ACCOUNT: this.settledForm.BANK_ACCOUNT,
          QUALIFICATION_DATA_LIST: this.QUALIFICATION_DATA_LIST,
        };
        if (this.settledForm.COMPANY_NATURE !== 0) {
          params.NATURE_CODE_LIST = this.settledForm.COMPANY_NATURE;
        } else {
          this.$message.show({ text: '请选择企业性质', type: 'warning' });
          return false;
        }
        if (this.file_name != '') {
          params.FILE_NAME = this.file_name;
        } else if (this.file_name == '' && this.CATALOG_ID_LIST.length != 0) {
          params.CATALOG_ID_LIST = this.CATALOG_ID_LIST;
        }
        http.post(params).then((result) => {
          this.$message.show({ text: '入驻成功', type: 'success' });
          this.active = 3;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }
    },
    Previous() {
      if (this.active-- < 0) this.active = 3;
    },
    // 移除上传图片
    handleRemove(file) {
      this.QUALIFICATION_DATA_LIST = this.QUALIFICATION_DATA_LIST.filter((item) => file.response.base_url + file.response.file_name != item.FILE_ARRAY.FILE_URL);
    },
    // 获取企业性质
    getCompanyNature() {
      const params = {
        SERVICE_ID: '16006',
        OTYPE: 2,
        COMPANY_ID: Number(this.$route.params.id),
      };
      http.post(params).then((result) => {
        if (result.length !== 0) {
          for (let i = 0; i < result.length; i++) {
            for (let j = 0; j < result[i].QUALIFICATION_DATA.length; j++) {
              result[i].QUALIFICATION_DATA[j].EXPIRE_DAY = '';
              result[i].QUALIFICATION_DATA[j].FILE_ARRAY = {};
            }
          }
          this.companyNatureList = result;
          this.settledForm.COMPANY_NATURE = 0;
        }
      }).catch((error) => {
        this.$message.show({ text: '请先配置企业资质', type: 'error' });
      });
    },
    // 下载可配置产品
    downloadConfigurable() {
      const params = {
        SERVICE_ID: '16006',
        OTYPE: 3,
        COMPANY_ID: Number(this.$route.params.id),
      };
      http.post(params).then((res) => {
        window.location.href = res[0].FILE_PATH;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 供应商资质上传限制文件类型
    checkFileType(file) {
      const fileName = file.name;
      const fileType = fileName.substring(fileName.lastIndexOf('.'));
      if (
        fileType === '.pdf'
        || fileType === '.xls'
        || fileType === '.xlsx'
        || fileType === '.doc'
        || fileType === '.docx'
        || fileType === '.jpg'
        || fileType === '.jpeg'
        || fileType === '.bmp'
        || fileType === '.gif'
        || fileType === '.png'
      ) {
        return true;
      }
      this.$message.show({ text: '资质上传文件类型不正确，请上传正确的类型', type: 'warning' });
      return false;
    },
    // 拉取邀请方产品分类
    getInviterCategory() {
      const params = {
        SERVICE_ID: '16006',
        OTYPE: 6,
        COMPANY_ID: Number(this.$route.params.id),
      };
      http.post(params).then((res) => {
        this.inviterCategoryList = res;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 移除已选择的企业性质时移除对应已上传文件
    removeQualification(val) {
      this.QUALIFICATION_DATA_LIST = this.QUALIFICATION_DATA_LIST.filter((item) => item.natureCode != val);
    },
    // 过期日期改变时修改已上传资质对应过期日期
    setExpireDay(item1) {
      this.QUALIFICATION_DATA_LIST.forEach((item2) => {
        if (item1.RELATION_ID == item2.RELATION_ID) {
          item2.EXPIRE_DAY = item1.EXPIRE_DAY;
        }
      });
    },
  },
};
</script>

<style>
.container {
  width: 100%;
  height: 100%;
  position: absolute;
  margin: 0;
  padding: 0;
  bottom: 0;
  background-color: #fff;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  -webkit-background-size: 100% 100%;
}

.el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
}

.el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
  line-height: 100px;
}

.el-form-item__label {
  text-align: justify;
}

.block {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/supplierManage/settledSupplierRegister.vue